import creditcard from './creditcard';
import neteller from './neteller';
import venuspoint from './venuspoint';
import vega from './vega';
import skrill from './skrill';
import banklocal from './banklocal';
import paypal from './paypal';
import trustly from './trustly';
import muchbetter from './muchbetter';
import bankdomestic from './bankdomestic';
import bankdomesticIBAN from './bankdomesticiban';
import bankinternationalIBAN from './bankinternationaliban';
import bankrepeat from './bankrepeat';
import instadebit from './instadebit';
import idebit from './idebit';
import ecopayz from './ecopayz';
import zimpler from './zimpler';
import interac from './interac';
import bankiban from './bankiban';
import astropaycard from './astropaycard';
import astropaybank from './astropaybank';
import bank from './bank';
import bankintl from './bankintl';
import jeton from './jeton';
import cryptocurrency from './cryptocurrency';
import bestpay from './bestpay';
import ezeewallet from './ezeewallet';
import mifinity from './mifinity';
import paramount from './paramount';
import cashlib from './cashlib';

export default {
  creditcard: creditcard,
  neteller: neteller,
  skrill: skrill,
  venuspoint: venuspoint,
  vega: vega,
  banklocal: banklocal,
  paypal: paypal,
  trustly: trustly,
  muchbetter: muchbetter,
  bankdomestic: bankdomestic,
  bankdomesticIBAN: bankdomesticIBAN,
  bankinternationalIBAN: bankinternationalIBAN,
  bankrepeat: bankrepeat,
  instadebit: instadebit,
  idebit: idebit,
  ecopayz: ecopayz,
  zimpler: zimpler,
  interac: interac,
  bankiban: bankiban,
  astropaycard: astropaycard,
  astropaybank: astropaybank,
  bank: bank,
  bankintl: bankintl,
  jeton: jeton,
  cryptocurrency: cryptocurrency,
  bestpay: bestpay,
  ezeewallet: ezeewallet,
  mifinity: mifinity,
  paramount: paramount,
  cashlib: cashlib
};